import { cardItems } from '@/mocks/homeData';

const cardImages = [
  'https://readdy.ai/api/search-image?query=dramatic%20warm%20toned%20night%20scene%2C%20crimson%20and%20amber%20mood%20lighting%2C%20abstract%20entertainment%20news%20aesthetic%2C%20editorial%20photography%2C%20no%20text%2C%20mysterious&width=600&height=600&seq=card-01-51cg&orientation=squarish',
  'https://readdy.ai/api/search-image?query=dark%20warm%20tone%20abstract%20social%20media%20aesthetic%2C%20crimson%20glow%2C%20soft%20dramatic%20lighting%2C%20editorial%20style%2C%20no%20text%2C%20mysterious%20atmosphere&width=600&height=600&seq=card-02-51cg&orientation=squarish',
  'https://readdy.ai/api/search-image?query=warm%20toned%20luxury%20abstract%20scene%2C%20dark%20amber%20and%20crimson%2C%20soft%20bokeh%2C%20cinematic%20mood%2C%20editorial%20style%2C%20no%20text&width=600&height=600&seq=card-03-51cg&orientation=squarish',
  'https://readdy.ai/api/search-image?query=dramatic%20backstage%20warm%20atmosphere%2C%20crimson%20and%20gold%2C%20soft%20spotlight%20glow%2C%20editorial%20photography%2C%20no%20text%2C%20mysterious&width=600&height=600&seq=card-04-51cg&orientation=squarish',
  'https://readdy.ai/api/search-image?query=warm%20toned%20abstract%20internet%20culture%20aesthetic%2C%20crimson%20ambient%2C%20soft%20dramatic%20mood%2C%20editorial%20style%2C%20no%20text%2C%20mysterious&width=600&height=600&seq=card-05-51cg&orientation=squarish',
  'https://readdy.ai/api/search-image?query=dark%20warm%20cinematic%20scene%2C%20crimson%20and%20amber%20accents%2C%20soft%20bokeh%2C%20editorial%20photography%2C%20no%20text%2C%20mysterious%20elegant&width=600&height=600&seq=card-06-51cg&orientation=squarish',
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full bg-background-50 py-14 md:py-20 px-4 md:px-6 lg:px-10">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-foreground-950 font-heading font-bold text-2xl md:text-3xl lg:text-4xl mb-3">
            深度爆料
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            每一条爆料都经过多源核实，帮你看清事件全貌
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              className="group relative aspect-square rounded-xl overflow-hidden cursor-pointer block"
            >
              <img
                src={cardImages[idx]}
                alt={item.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-5 md:p-6">
                <h3 className="text-white font-heading font-bold text-lg md:text-xl leading-snug mb-1">
                  {item.title}
                </h3>
                <p className="text-white/70 text-xs md:text-sm">
                  {item.subtitle}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}